// extracted by mini-css-extract-plugin
export default {"popper":"popper__hoNuu","paper":"paper__YTf0d"};